/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import Filterizr from 'filterizr';
import $ from 'jquery';
import * as React from 'react';
import { StoreBanner, StoreFilter, StoreInfo } from './components';
import { IOurStoresArViewProps } from './our-stores-ar';

export default (props: IOurStoresArViewProps) => {
  Filterizr.installAsJQueryPlugin($);
  $(document).ready(() => $('.filtr-container').filterizr());

  return (
    <React.Fragment>
      <div className='row'>
        <StoreBanner />
      </div>
      <div className='row'>
        <ul className='simplefilter col-md-12'>
          <StoreFilter />
        </ul>
      </div>
      <div className='row paddingSide50'>
        <div className='filtr-container'>
          <StoreInfo />
        </div>
      </div>
    </React.Fragment>
  );
};
